import elCorteInglesLogo from 'assets/images/el-corte-ingles-logo.svg';

export type EsRetailerId = 'elcorteingles';

export type EsRetailer = {
  id: EsRetailerId;
  url: string;
  logoSrc?: string;
};

/**
 * Spain sale window: 6–12 October 2026, Madrid time.
 * Spain is on CEST (UTC+2) for the entire window (DST ends 25 Oct).
 * End bound is exclusive: the popup stops at midnight after 12 Oct.
 */
export const ES_SALE_STARTS_AT = Date.parse('2026-10-06T00:00:00+02:00');
export const ES_SALE_ENDS_AT = Date.parse('2026-10-13T00:00:00+02:00');

export const isEsSaleLive = (now: number = Date.now()): boolean =>
  now >= ES_SALE_STARTS_AT && now < ES_SALE_ENDS_AT;

const UTM_PARAMS = {
  utm_source: 'ultrahuman',
  utm_medium: 'site-banner',
  utm_campaign: 'es-promo-oct26',
} as const;

const withUtms = (baseUrl: string, retailer: EsRetailerId): string => {
  const url = new URL(baseUrl);
  Object.entries(UTM_PARAMS).forEach(([key, value]) => {
    url.searchParams.set(key, value);
  });
  url.searchParams.set('utm_content', retailer);
  return url.toString();
};

export const ES_RETAILERS: EsRetailer[] = [
  {
    id: 'elcorteingles',
    url: withUtms(
      'https://www.elcorteingles.es/ultrahuman/electronica/',
      'elcorteingles',
    ),
    logoSrc: elCorteInglesLogo.src,
  },
];
